import { APP_CONFIG } from '../../../../config';
import { TransformInitOptions } from '../../../../middleware';
import { AppState } from '../../../app.types';

/**
 * Translations for Portal user profiles data are handled in the backend,
 * a header is expected to for the translation to be determined.
 * The locale set is determined via url params or the browser default.
 * See the app initilization method getLocale().
 */
export function addLocaleHeader ({
    init,
    state
}: TransformInitOptions<AppState>) {
    return {
        ...init.headers,
        // if the fallback locale is loaded, that is added here
        Locale: state.app.localeLoaded || APP_CONFIG.defaultLocale
    };
}
